export { ConfirmedOrderCard } from './ConfirmedOrderCard';
export type { ConfirmedOrderCardProps } from './ConfirmedOrderCard';
